import PropTypes from 'prop-types';
import { BrandCanvas, BrandLogo } from '@shared/ui';
import './BrandPanel.css';

/**
 * BrandPanel — the dark, animated, clipped left side of the public
 * pages. Carries the QHSLab logo + welcome line + tagline.
 *
 * On tablet (≤960 px) it stacks above the form area as a 260 px banner
 * with a softer clip path (the AuthShell media queries handle layout —
 * this component only worries about its inner content).
 */
const BrandPanel = ({
  welcome = 'Welcome to the',
  welcomeStrong = 'Quality Health System (QHS)',
  tagline = 'The intelligent healthcare platform for better patient outcomes.',
  attribution = 'Powered by QHSLab, Inc.',
}) => (
  <aside className="qhs-auth-brand-panel" aria-label="QHSLab">
    <BrandCanvas>
      <div className="qhs-auth-brand-panel__content">
        <BrandLogo
          variant="wordmark"
          tone="white"
          size={220}
          className="qhs-auth-brand-panel__logo"
        />
        <h1 className="qhs-auth-brand-panel__welcome">
          {welcome} <strong>{welcomeStrong}</strong>
        </h1>
        <p className="qhs-auth-brand-panel__tagline">{tagline}</p>
        {attribution && <p className="qhs-auth-brand-panel__attribution">{attribution}</p>}
      </div>
    </BrandCanvas>
  </aside>
);

BrandPanel.propTypes = {
  welcome: PropTypes.string,
  welcomeStrong: PropTypes.string,
  tagline: PropTypes.string,
  attribution: PropTypes.string,
};

export default BrandPanel;
